export const columnsCsv = [
  { key: "date", label: "Date" },
  { key: "userName", label: "User name" },
  { key: "email", label: "Email" },
  { key: "lastLoginDateTime", label: "Last logged in Date Time" },
  {
    key: "action",
    label: "Action",
  },
];
export const options = [
  { value: "Admin", label: "Admin" },
  { value: "Callcentreagent", label: "Call Centre Agent" },
  { value: "Customerserviceagent", label: "Customer Service Agent" },
  { value: "Superadmin", label: "Super Admin" },
];
